<template>
  <v-container class="fill-height">
    <v-form ref="loginForm" class="w-100">
      <v-row>
        <v-col cols="12" sm="12" md="10" lg="7" class="d-lg-flex d-md-flex mx-auto elevation-5 pa-0 login rounded"
               >
          <v-col cols="12" sm="12" md="6" lg="6" class="pt-5" :class="$vuetify.breakpoint.mdAndUp ? 'pa-16' :'pa-10'">
            <!--          :class="$vuetify.breakpoint.smOnly ?'pa-10' :'pa-15'"
            :class="$vuetify.breakpoint.mdOnly ? 'rounded-r-xl' : 'rounded-r-lg'"
            -->
            <v-img src="/img/logo.png" width="50" class="mx-auto"/>
            <h4 class=" text-center mx-auto my-3">Tebyan Smart CRM</h4>
            <v-text-field
              label="نام کاربری"
              outlined
              dense
              :rules="[required]"
              v-model="userName"
            ></v-text-field>
            <v-text-field
              class="mt-2"
              label="پسورد"

              outlined
              type="password"
              :rules="[required]"
              dense
              v-model="password"
            ></v-text-field>
            <v-btn
              class="primary iranSansBold mx-auto w-100"
              @click="login">ورود
            </v-btn>
            <!--          <v-btn color="primary"  @click="login">  ورود </v-btn>-->
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6"
                 class="primary d-flex  align-center rounded-left "
                 :class="$vuetify.breakpoint.smAndDown ? 'rounded-r-lg' :'rounded-r-xl'">
            <div class="mx-auto">
              <v-img src="/img/login.png" width="200px"  class="mx-auto"/>

            </div>

          </v-col>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {required,verifyMobilePhone} from "../plugins/rules";

export default {
  name: "Login",
  data() {
    return {
      userName: '',
      password: '',
    }
  },
  methods: {
    required: required('این مود الزامی است'),
    verifyMobilePhone:verifyMobilePhone(),
    async login() {
      if (this.$refs.loginForm.validate()) {
          if(this.userName == 'crm' && this.password == 'crmcrm'){
            await this.$store.dispatch('auth/fakeLogin')
            await  this.$router.push({name:"Dashboard"})
          }else{
            await  this.$router.push({name:"Page403"})
          }
        // let data = await this.$store.dispatch("auth/login", {
        //   "phoneNumber": this.userName,
        //   "password": this.password
        // })
        // if(data.status == "ok" && data.data ){
        //   await  this.$router.push({name:"Dashboard"})
        // }
      }
    },
  }
};
</script>
<style>
.login,
.login .col-6 {
  min-height: 300px;
}

.v-btn__content {
  font-weight: bold;
  font-size: 13px;
}
.myW{
  width: 50% !important;
  margin: 0 auto;
}
</style>
